import React, { useState, useEffect } from 'react';
import './index.less';
import { Tooltip } from 'antd';
import apis from './apis.js';
import NoticePopup from './components/popup';
import { connect } from 'react-redux';
import ComponentLog from '@/components/component-log';
import { Carousel } from '@drip/drip-design';

const CommonAsk = () => {
  const [noticeList, setNoticeList] = useState([]);
  const [noticePopList, setNoticePopList] = useState([]);

  useEffect(() => {
    const conditions = {
      currentPage: 1,
      pageSize: 3,
      status: 1,
      title: '',
      platform: 1,
    };
    apis
      .AnnounceList(conditions)
      .then((res) => {
        if (res && res.ret === '0') {
          if (res.data?.list && res.data.list.length > 0) setNoticeList(res.data.list.splice(0, 3));
        }
      })
      .catch((err) => {
        console.log(err);
      });
    apis
      .AnnounceShow()
      .then((res) => {
        if (res && res.ret === '0') {
          setNoticePopList(res.data.list);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function toNoticeCenter(id) {
    const url = id ? `/notice/${id}` : '/notice';
    window.open(url);
  }

  return (
    <div>
      <div className="commonAsk-wrapper">
        <div className="notice-wrap">
          {noticeList.length > 0 ? (
            <div className="content-wrap">
              <ComponentLog>
                <div clstag="yx_center|workbench_sidequestionclick" className="item">
                  <div className="item-head">公告</div>
                  {noticeList.length > 1 ? (
                    <Carousel dotPosition="right" dots={false} autoplay className="items-carousel">
                      {noticeList.map((item) => {
                        return (
                          <div key={item.id} onClick={() => toNoticeCenter(item.id)}>
                            <div className="item-wrapper">
                              <Tooltip title={item.title} arrowPointAtCenter placement="bottom">
                                <span className="notice-item-title">{item.title}</span>
                              </Tooltip>
                              <span className="new-badge">New</span>
                            </div>
                          </div>
                        );
                      })}
                    </Carousel>
                  ) : (
                    <div className="item-wrapper" onClick={() => toNoticeCenter(noticeList[0].id)}>
                      <Tooltip title={noticeList[0].title} arrowPointAtCenter placement="bottom">
                        <span className="notice-item-title">{noticeList[0].title}</span>
                      </Tooltip>
                      <span className="new-badge">New</span>
                    </div>
                  )}
                </div>
              </ComponentLog>
            </div>
          ) : null}
        </div>

        {noticePopList.length > 0 ? <NoticePopup noticePopList={noticePopList} /> : null}
      </div>
    </div>
  );
};
export default connect((state) => {
  return {
    noticePopInfo: state.noticePopInfo,
  };
}, {})(CommonAsk);
